/**
 * 워크스페이스 노출 플래그 SSoT — 축·보관함 종류를 **화면에서만 숨긴다**.
 *
 * 여기 적힌 축은 GNB 진행 레일·랜딩 축 카드·보관함(필터 칩·최신 스트립·드롭다운·`?kind=`·전체 목록)에서 빠진다.
 * 라우트·API·데이터는 그대로라 직접 URL 진입은 된다 — 되살릴 때는 아래 두 배열만 비우면 된다.
 *
 * 서버 미러: 보관함 "전체" 목록의 페이징은 서버가 소유하므로 `ReportKind`(enum) 의 `hidden` 이 같은 종류를 UNION 에서 뺀다.
 * FE 만 걸러내면 `totalElements` 가 어긋나 [더 보기] 가 빈 페이지를 만든다 — 두 곳을 함께 바꾼다.
 *
 * type-only import 라 workspaceNav/reportRegistry 와 순환이 생기지 않는다.
 */
import type { ReportKind } from './reportRegistry';
import type { WorkspaceNavKey } from './workspaceNav';

/** 숨긴 GNB 축 — 진로심리검사(코드·라우트 유지, 노출만 끔). */
export const HIDDEN_NAV_KEYS: readonly WorkspaceNavKey[] = ['test'];

/** 숨긴 보관함 종류 — 검사 결과(서버 `ReportKind.ASSESSMENT.hidden` 과 미러). */
export const HIDDEN_ARCHIVE_KINDS: readonly ReportKind[] = ['ASSESSMENT'];

export function isNavVisible(key: WorkspaceNavKey): boolean {
  return !HIDDEN_NAV_KEYS.includes(key);
}

export function isArchiveKindVisible(kind: ReportKind): boolean {
  return !HIDDEN_ARCHIVE_KINDS.includes(kind);
}
